export default "__VITE_ASSET__Ba_m9coV__"